module.exports = __webpack_public_path__ + "static/unsecured-shield.34dcae4b.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/unsecured-shield.png
// module id = 479
// module chunks = 201563372448855 213534597649335